/** Иконка и подпись способа оплаты для истории транзакций. */
export function getPaymentMethodDisplay(method, t) {
    const key = (method || '').toLowerCase();
    const map = {
        online_card: { icon: '💳', label: t('common:payment.online') },
        online_sbp: { icon: '💳', label: t('common:payment.online') },
        online: { icon: '💳', label: t('common:payment.online') },
        cash: { icon: '💵', label: t('common:payment.cash') },
        card_transfer: { icon: '🏦', label: t('common:payment.cardTransfer') },
        card_terminal: { icon: '💳', label: t('common:payment.online') },
        sbp_qr: { icon: '💳', label: t('common:payment.online') },
        balance: { icon: '💰', label: t('balance:tx.deposit', { defaultValue: 'Пополнение' }) },
    };
    return map[key] || null;
}
